import { render, staticRenderFns } from "./OtherDocumentsList.vue?vue&type=template&id=a78c71c4&scoped=true"
import script from "./OtherDocumentsList.vue?vue&type=script&lang=js"
export * from "./OtherDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./OtherDocumentsList.vue?vue&type=style&index=0&id=a78c71c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c71c4",
  null
  
)

export default component.exports